import {ValueObject} from '@s-ui/domain'

import {ImagesResourcesValueObject} from './ImagesResourcesValueObject.js'
import {VideosResourcesValueObject} from './VideosResourcesValueObject.js'

export class ResourcesValueObject extends ValueObject {
  #images
  #videos

  constructor({images, videos}) {
    super()
    this.#images = images
    this.#videos = videos
  }

  static createFromListingApi({resources, videos}) {
    return new ResourcesValueObject({
      images: ImagesResourcesValueObject.createFromListingApi({resources: resources || []}),
      videos: VideosResourcesValueObject.createFromListingApi({videos: videos || []})
    })
  }

  get images() {
    return this.#images.value
  }

  get videos() {
    return this.#videos.value
  }

  get value() {
    return {
      images: this.images,
      videos: this.videos
    }
  }
}
